export default {
  toasts: {
    verification_pending: 'La verifica è ancora in attesa',
  },
};
